module.exports = __webpack_public_path__ + "media/headerBg.0e03f022.mp4";